{
  "name": "npm-registry-fetch",
  "version": "19.1.1",
  "description": "Fetch-based http client for use with npm registry APIs",
  "main": "lib",
  "files": [
    "bin/",
    "lib/"
  ],
  "scripts": {
    "eslint": "eslint \"**/*.{js,cjs,ts,mjs,jsx,tsx}\"",
    "lint": "npm run eslint",
    "lintfix": "npm run eslint -- --fix",
    "test": "tap",
    "posttest": "npm run lint",
    "npmclilint": "npmcli-lint",
    "postsnap": "npm run lintfix --",
    "postlint": "template-oss-check",
    "snap": "tap",
    "template-oss-apply": "template-oss-apply --force"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/npm/npm-registry-fetch.git"
  },
  "keywords": [
    "npm",
    "registry",
    "fetch"
  ],
  "author": "GitHub Inc.",
  "license": "ISC",
  "dependencies": {
    "@npmcli/redact": "^4.0.0",
    "jsonparse": "^1.3.1",
    "make-fetch-happen": "^15.0.0",
    "minipass": "^7.0.2",
    "minipass-fetch": "^5.0.0",
    "minizlib": "^3.0.1",
    "npm-package-arg": "^13.0.0",
    "proc-log": "^6.0.0"
  },
  "devDependencies": {
    "@npmcli/eslint-config": "^6.0.0",
    "@npmcli/template-oss": "4.28.0",
    "cacache": "^20.0.0",
    "nock": "^13.2.4",
    "require-inject": "^1.4.4",
    "ssri": "^13.0.0",
    "tap": "^16.0.1"
  },
  "tap": {
    "check-coverage": true,
    "test-ignore": "test[\\\\/](util|cache)[\\\\/]",
    "nyc-arg": [
      "--exclude",
      "tap-snapshots/**"
    ]
  },
  "engines": {
    "node": "^20.17.0 || >=22.9.0"
  },
  "templateOSS": {
    "//@npmcli/template-oss": "This file is partially managed by @npmcli/template-oss. Edits may be overwritten.",
    "version": "4.28.0",
    "publish": "true"
  }
}
